import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: [theme.spacing.sp03, theme.spacing.sp04],
      borderBottom: [1, 'solid', theme.colors.borderSubtle],
    },

    title: {
      color: theme.colors.textPrimary,
    },

    arrows: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
    },

    arrow: {
      cursor: 'pointer',
      color: theme.colors.iconTertiary,
      flexShrink: 0,
    },
  },
  {
    name: 'CalendarHeader',
  },
);
